import { AutoNavigate } from '@betterment/js-runtime';
import { RouteObject } from 'react-router-dom';

import { echoRoutes } from './EchoRoutes';

import urlBuilder from '../../Shared/url-builder';
import { HouseholdActivity } from '../activity/ActivityPage';
import { ClientAgreementSignaturesPage } from '../ClientAgreementSignatures';
import { CreateBillingPlanFlowPage } from '../ClientBilling/BillingPlans/CreateBillingPlanFlow';
import { EditBillingPlanFlowPage } from '../ClientBilling/BillingPlans/EditBillingPlanFlow';
import { BillingPlanIndexPage } from '../ClientBilling/BillingPlans/index/BillingPlanIndexPage';
import { OnDemandBillingIndexPage } from '../ClientBilling/OnDemandBilling/index/OnDemandBillingIndexPage';
import { OnDemandBillingFlow } from '../ClientBilling/OnDemandBilling/OnDemandBillingFlow';
import { OnDemandBillingResolve } from '../ClientBilling/OnDemandBilling/Resolve';
import { OnDemandBillingReview } from '../ClientBilling/OnDemandBilling/Review';
import { OnDemandBillingStart } from '../ClientBilling/OnDemandBilling/start';
import AcatsApprovals from '../CoPilot/AcatsApprovals';
import AccountApprovals from '../CoPilot/AccountApprovals';
import AccountLockouts from '../CoPilot/AccountLockouts';
import FailedAcats from '../CoPilot/FailedAcats';
import MissingBeneficiaries from '../CoPilot/MissingBeneficiaries';
import PendingAcats from '../CoPilot/PendingAcats';
import PendingInvites from '../CoPilot/PendingInvites';
import Rmds from '../CoPilot/Rmds';
import { CustomFundLineupFlow } from '../CustomFundLineup/CustomFundLineupFlow';
import FirmIntegrationsPage from '../FirmIntegrations/FirmIntegrationsPage';
import { AccountOverview } from '../Household/AccountOverview/AccountOverview';
import { AddSpouseParticipant } from '../Household/AddSpouseParticipant';
import { EditSecuritiesLending } from '../Household/HouseholdSummary/EditSecuritiesLending';
import { Summary } from '../Household/HouseholdSummary/Summary';
import { SwitchBillingPlan } from '../Household/HouseholdSummary/SwitchBillingPlan';
import { OtherSpouseParticipant } from '../Household/OtherSpouseParticipant';
import { ParticipantSelectionStepProps } from '../Household/ParticipantSelectionStep';
import { SellOrderFlow } from '../Household/sell-order/SellOrderFlow';
import { SupportPage } from '../Support/SupportPage';

export function getRoutes(
  isSingleUserHousehold?: boolean,
  partcipantSelectionProps?: ParticipantSelectionStepProps
): RouteObject[] {
  return [
    {
      path: urlBuilder.getHouseholdSummaryPage.absolutePath,
      element: <Summary />,
    },
    {
      path: urlBuilder.getClientAgreementSignaturePage.absolutePath,
      element: <ClientAgreementSignaturesPage />,
    },
    {
      path: urlBuilder.getHouseholdAccountPage.absolutePath,
      element: <AccountOverview />,
    },
    {
      path: urlBuilder.getHouseholdsActivityPage.absolutePath,
      element: <HouseholdActivity />,
    },
    {
      path: `${urlBuilder.getSecuritySellOrderFlow.absolutePath}/*`,
      element: <SellOrderFlow />,
    },
    {
      path: urlBuilder.getSolo401kAddSpouseParticipantPage.absolutePath,
      element: (
        <AddSpouseParticipant
          // @ts-expect-error TS2322 violates strict null checks
          isSingleUserHousehold={isSingleUserHousehold}
          // @ts-expect-error TS2322 violates strict null checks
          partcipantSelectionProps={partcipantSelectionProps}
        />
      ),
    },
    {
      path: urlBuilder.getSolo401kOtherSpouseParticipantPage.absolutePath,
      element: <OtherSpouseParticipant />,
    },
    {
      path: urlBuilder.getBillingPlanIndexPage.absolutePath,
      element: <BillingPlanIndexPage />,
    },
    {
      path: `${urlBuilder.getEditBillingPlanFlowRoute.absolutePath}/*`,
      element: <EditBillingPlanFlowPage />,
    },
    {
      path: `${urlBuilder.getCustomFundLineupPage.absolutePath}/*`,
      element: <CustomFundLineupFlow />,
    },
    {
      path: `${urlBuilder.getCreateBillingPlanFlowRoute.absolutePath}/*`,
      element: <CreateBillingPlanFlowPage />,
    },
    {
      path: urlBuilder.getOnDemandBillingIndexPage.absolutePath,
      element: <OnDemandBillingIndexPage />,
    },
    {
      path: urlBuilder.getOnDemandBillingStartPage.absolutePath,
      element: (
        <OnDemandBillingFlow>
          <OnDemandBillingStart />
        </OnDemandBillingFlow>
      ),
    },
    {
      path: urlBuilder.getOnDemandBillingReviewPage.absolutePath,
      element: (
        <OnDemandBillingFlow>
          <OnDemandBillingReview />
        </OnDemandBillingFlow>
      ),
    },
    {
      path: urlBuilder.getOnDemandBillingResolvePage.absolutePath,
      element: (
        <OnDemandBillingFlow>
          <OnDemandBillingResolve />
        </OnDemandBillingFlow>
      ),
    },
    {
      path: urlBuilder.getSettingsIntegrationsPage.absolutePath,
      element: <FirmIntegrationsPage />,
    },
    {
      path: urlBuilder.getCoPilotPage.absolutePath,
      element: <AutoNavigate to={urlBuilder.getCoPilotAccountApprovalsPage.absolutePath} />,
    },
    {
      path: urlBuilder.getCoPilotAccountApprovalsPage.absolutePath,
      element: <AccountApprovals />,
    },
    {
      path: urlBuilder.getCoPilotPendingInvitesPage.absolutePath,
      element: <PendingInvites />,
    },
    {
      path: urlBuilder.getCoPilotMissingBeneficiariesPage.absolutePath,
      element: <MissingBeneficiaries />,
    },
    {
      path: urlBuilder.getCoPilotPendingAcatsPage.absolutePath,
      element: <PendingAcats />,
    },
    {
      path: urlBuilder.getCoPilotFailedAcatsPage.absolutePath,
      element: <FailedAcats />,
    },
    {
      path: urlBuilder.getCoPilotAcatsApprovalsPage.absolutePath,
      element: <AcatsApprovals />,
    },
    {
      path: urlBuilder.getCoPilotRmdsPage.absolutePath,
      element: <Rmds />,
    },
    {
      path: urlBuilder.getCoPilotAccountLockoutsPage.absolutePath,
      element: <AccountLockouts />,
    },
    {
      path: urlBuilder.getHouseholdBillingPlanEditPage.absolutePath,
      element: <SwitchBillingPlan />,
    },
    {
      path: urlBuilder.getEditSecuritiesLendingPage.absolutePath,
      element: <EditSecuritiesLending />,
    },
    {
      path: urlBuilder.getSupportPage.absolutePath,
      element: <SupportPage />,
    },
    ...echoRoutes,
  ];
}
